import React from "react";
import {quoteCallNumber as defaultCallNumber, whatsappContacts as defaultWhatsappContacts} from "../../Utils/Data";

/**
 * Call + WhatsApp picker (Dubai/UAE). Same UX as header “Get a quote”.
 * Optional `callNumber` / `contacts` let parents import from Data and pass through (avoids duplicate markup in Header).
 */
export default function BookNowModal({
    open,
    onClose,
    heading = "Book now",
    note,
    callNumber = defaultCallNumber,
    contacts = defaultWhatsappContacts,
}) {
    if (!open) return null;

    return (
        <div
            onClick={onClose}
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(0, 0, 0, 0.45)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 999999,
                padding: "16px",
            }}
        >
            <div
                onClick={(event) => event.stopPropagation()}
                style={{
                    width: "100%",
                    maxWidth: "420px",
                    background: "#fff",
                    borderRadius: "12px",
                    padding: "24px",
                    maxHeight: "min(90vh, 560px)",
                    overflowY: "auto",
                }}
            >
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="m-0">{heading}</h4>
                    <button
                        type="button"
                        onClick={onClose}
                        style={{
                            border: "none",
                            background: "transparent",
                            fontSize: "22px",
                            lineHeight: "1",
                            cursor: "pointer",
                        }}
                        aria-label="Close"
                    >
                        &times;
                    </button>
                </div>
                {note ? (
                    <p className="mb-2 small text-muted">{note}</p>
                ) : null}
                <p className="mb-3">Choose your preferred contact method:</p>
                <div className="d-flex flex-column gap-2">
                    <a
                        href={`tel:${callNumber}`}
                        className="ca-btn-primary-3 theme-bg-3 text-white br-50 text-center py-2"
                    >
                        <i className="fa-solid fa-phone me-2"/> Call {callNumber}
                    </a>
                    <p className="mb-1 small text-muted">WhatsApp — pick a contact:</p>
                    {contacts.map((c) => (
                        <a
                            key={c.waId}
                            href={`https://wa.me/${c.waId}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="ca-btn-primary-3 text-white br-50 text-center py-2"
                            style={{backgroundColor: "#25D366"}}
                        >
                            <i className="fa-brands fa-whatsapp me-2"/>
                            {c.owner} — {c.phoneDisplay}
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
}
